import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { INDIGO, SLATE } from "../../../constants/Colors";

/**
 * Confirmation dialog before exporting URLs to CSV.
 */
export default function ExportConfirmDialog({ open, onClose, onConfirm, count, total }) {
  const isFiltered = count != null && total != null && count !== total;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth sx={{ zIndex: 21474837 }}>
      <DialogTitle sx={{ fontSize: "1rem", fontWeight: 600, color: SLATE[900], pb: 1 }}>
        Export URLs
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: "0.875rem", color: SLATE[600] }}>
          This will export <strong>all URLs matching your current filters</strong> — not just this page.
        </Typography>
        {(count ?? total) != null && (
          <Box sx={{ mt: 1.5, px: 2, py: 1, bgcolor: SLATE[50], borderRadius: "8px", border: `1px solid ${SLATE[200]}` }}>
            <Typography sx={{ fontSize: "0.8125rem", color: SLATE[700] }}>
              <strong>{(count ?? total).toLocaleString()}</strong> URLs will be exported
            </Typography>
            {isFiltered && (
              <Typography sx={{ fontSize: "0.75rem", color: SLATE[400], mt: "2px" }}>
                {total.toLocaleString()} total — filtered to {count.toLocaleString()} by active filters
              </Typography>
            )}
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          size="small"
          sx={{ borderColor: SLATE[300], color: SLATE[700], textTransform: "none" }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          size="small"
          sx={{ textTransform: "none", fontSize: "0.875rem", fontWeight: 500, boxShadow: "none", "&:hover": { boxShadow: "none" } }}
        >
          Export
        </Button>
      </DialogActions>
    </Dialog>
  );
}
